import React, { PropsWithChildren, useEffect, useMemo } from "react";
import events from "analytics/events";
import { initializeAnalytics, setAnalyticsIdentity } from "analytics/client";
import { AnalyticsContext } from "analytics/context";
import { useAnalyticsProvider } from "@shared/analytics/hooks";
import useMedia from "utils/hooks/useMedia";
import { getMixpanelToken } from "utils/analytics";
import { useTelegramInitData } from "utils/hooks/useTelegramWebApp";
import { IS_TELEGRAM_WEB_APP } from "features/telegram/constants";

export { AnalyticsContext } from "analytics/context";

const AnalyticsProvider = ({ children }: PropsWithChildren) => {
  const systemDarkMode = useMedia(
    ["(prefers-color-scheme: dark)"],
    [true],
    false
  );
  const {
    setIsInitialized,
    modifiedAnalytics,
    deferredAnalytics,
    setExtraLoginParams,
  } = useAnalyticsProvider(
    events,
    setAnalyticsIdentity,
    systemDarkMode,
    IS_TELEGRAM_WEB_APP
  );
  const { initData } = useTelegramInitData();
  useEffect(() => {
    initializeAnalytics(getMixpanelToken());
    if (!initData) setIsInitialized(true);
  }, [initData, setIsInitialized]);
  const value = useMemo(
    () => ({
      analytics: modifiedAnalytics,
      deferredAnalytics,
      setIsInitialized,
      setExtraLoginParams,
    }),
    [
      modifiedAnalytics,
      deferredAnalytics,
      setIsInitialized,
      setExtraLoginParams,
    ]
  );
  return (
    <AnalyticsContext.Provider value={value}>
      {children}
    </AnalyticsContext.Provider>
  );
};

export default AnalyticsProvider;
